import React from 'react';
import { XIcon } from 'lucide-react';
import { notForYou } from '../data/masterclass';
export function WhoThisIsNotFor() {
  return <section aria-labelledby="not-for-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-177" data-mp="2f5c09cjicfrl">
      <div className="mx-auto w-full max-w-5xl px-6 py-20 lg:py-28" data-id="element-178" data-mp="2b5jqiwido3kn">
        <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-179" data-mp="267i4q3tkhq5h">
          Who this is not for
        </p>
        <h2 id="not-for-heading" className="mt-4 max-w-3xl font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-180" data-mp="32voe141fp6q3">
          Unified Success is not for everybody.
        </h2>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" data-id="element-181" data-mp="2owoolu63knsv">
          {notForYou.lines.map(line => <li key={line} className="flex items-start gap-4 rounded-2xl border border-ink-line bg-ink p-6 text-white/70" data-id="element-182" data-mp="1igcqtu76t7xt">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold/60" aria-hidden="true" data-id="element-183" data-mp="1dg89y32dab72" />
              <span data-id="element-184" data-mp="22cwmxno6pr36">{line}</span>
            </li>)}
        </ul>

        <p className="mt-12 font-display text-2xl font-semibold uppercase leading-snug text-gold sm:text-3xl" data-id="element-185" data-mp="26cp06doiwlev">
          {notForYou.close}
        </p>
      </div>
    </section>;
}